const OtpLifetimeUnitEnum = Object.freeze({
  1: 'Seconds',
  2: 'Minutes',
  3: 'Hours',
  4: 'Days'
})

export { OtpLifetimeUnitEnum }



// WEBPACK FOOTER //
// ./src/modules/integrations/types/otp/enums/OtpLifetimeUnitEnum.js